import React, {SetStateAction, useEffect} from "react";
import {Card, Col, Row} from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import {useTranslation} from "react-i18next";
import {useNavigate, useParams} from "react-router-dom";
import Select from "react-select";
import {ErrorToast} from "../../../shared/toasters/toasters";
import {AdminBannerService} from "../service";
import {PICTURE_URL} from "../../../helpers/api.routes";
import {IBanner} from "../interface";

interface IProps {
  state: IBanner | null;
  setState: React.Dispatch<SetStateAction<IBanner | null>>;
  setImage: React.Dispatch<SetStateAction<File | null>>;
  zones: any
}
export const CreateForm = ({ state, setState, setImage, zones }: IProps) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const changeHandler = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target;
    setState((prev: any) => ({ ...prev, [name]: value }));
  };
  const selectHandler = (e: any) => {
    setState((prev: any) => ({ ...prev, zone: e.value }));
  };
  const mappedData = zones?.map((zone: any) => ({
    label: zone.zone,
    value: zone.id,
  }));
  const switchHandler2 = (e: any) => {
    setState((prev: any) => ({ ...prev, [e.target.name]: e.target.checked }));
  };
  const fileHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.files && setImage(e.target.files[0]);
  };

  useEffect(() => {
    if (!!Number(id)) {
      AdminBannerService.getSingle(+id!)
        .then((response) => {
          const { data } = response;
          setState({...data, isActive: data?.active});
          window.scrollTo(0, 0);
        })
        .catch(ErrorToast);
    }
  }, [id]);

  return (
    <>
      <Card>
        <Card.Body>
          <Row>
            <Col md={5} className="mb-3">
              <label htmlFor="title" className="required-field">
                {t("global.title")}
              </label>
              <input
                type="text"
                name="title"
                className="form-control"
                required
                onChange={changeHandler}
                value={state?.id && state?.title}
              />
            </Col>

            <Col md={5}>
              <label htmlFor="category" className="required-field">
                {t("table_headers.zone")}
              </label>
              <Select
                className="react-select-field"
                onChange={selectHandler}
                options={mappedData}
                value={mappedData?.find(
                  (category: any) => category.value === state?.zone?.id
                )}
              />
            </Col>
            <Col md={2} className="mt-2">
              <label
                className="d-block text-start"
                htmlFor="flexSwitchCheckDefault"
              >
                {t("global.active")}
              </label>
              <div className="form-check form-switch">
                <input
                  className="form-check-input switch-custom"
                  type="checkbox"
                  name="isActive"
                  checked={state?.isActive}
                  onChange={switchHandler2}
                  role="switch"
                  id="flexSwitchCheckDefault"
                />
              </div>
            </Col>
            <Col md={12}>
              <label htmlFor="category" className="required-field">
                {t("global.code")}
              </label>
              <textarea
                className="form-control"
                id={`code`}
                rows={6}
                name="code"
                value={state?.code}
                onChange={changeHandler}
              ></textarea>
            </Col>
            <Col md={5} className="mt-3">
              <label htmlFor="sponsorTitle" className="required-field">
                {t("banner.sponsor_title")}
              </label>
              <input
                  type="text"
                  name="sponsorTitle"
                  className="form-control"
                  onChange={changeHandler}
                  value={state?.id && state?.sponsorTitle}
              />
            </Col>
            <div className="mt-3">
              <label htmlFor="imageFile"> {t("download.image")}</label>
              <input
                  onChange={fileHandler}
                  className="form-control"
                  type="file"
                  accept="image/*"
                  id="imageFile"
              />
            </div>
            {state?.image && (
                <div className="d-flex align-items-center mt-3">
                  <img
                      className="object-fit-cover"
                      width={200}
                      height={200}
                      src={PICTURE_URL + state?.image.path}
                      data-holder-rendered="true"
                      alt={state?.image?.name}
                      style={{margin: '2px'}}
                  />
                </div>
            )}
          </Row>
          <div className="col-12 my-2 d-flex justify-content-end text-align-center">
            <div>
              <button
                className="btn btn-info"
                type={'button'}
                onClick={() => navigate("/admin/banner")}
              >
                {t("global.cancel")}
              </button>
              <button className="btn btn-primary ms-3" type="submit">
                {state?.id
                  ? `  ${t("global.update")}`
                  : `${t("global.create")}`}
              </button>
            </div>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
